import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'
import ConfirmDeleteDialog from '@/Components/Form/ConfirmDeleteDialog'
import { ContentDossierDeleteProps, ContentDossierDeleteState } from '../types'
import { ToolbarButton } from '@/Components/Elements/StyledComponents/Buttons'
class ContentDossierDelete extends React.Component<
    ContentDossierDeleteProps,
    ContentDossierDeleteState
> {
    constructor(props: ContentDossierDeleteProps) {
        super(props)

        this.state = {
            DeleteDefDossierForm: false,
        }
    }

    render() {
        const itemName = [
            this.props.defdossier?.name_singular,
            this.props.dossier?.summary,
        ]
            .filter(Boolean)
            .join(' / ')

        return (
            <>
                {this.state.DeleteDefDossierForm ? (
                    <ConfirmDeleteDialog
                        kedo={this.props.kedo}
                        onClose={() =>
                            this.setState({ DeleteDefDossierForm: false })
                        }
                        url={
                            this.props.kedo.api().getContentDossierEndpoint() +
                            '/' +
                            this.props.dossier.id
                        }
                        onSuccess={
                            this.props.onSuccess
                                ? this.props.onSuccess
                                : () => {
                                      window.location =
                                          '/defdossier/' +
                                          this.props.dossier.def_dossier_id
                                  }
                        }
                        itemName={itemName ? `"${itemName}"` : ''}
                    />
                ) : null}
                <ToolbarButton
                    dense={this.props.size === 'sm'}
                    variant="outlined"
                    invert
                    color={'error'}
                    onClick={() =>
                        this.setState({
                            DeleteDefDossierForm: true,
                            loading: true,
                        })
                    }
                >
                    <FontAwesomeIcon icon={faTrashAlt} />
                </ToolbarButton>
            </>
        )
    }
}

export default ContentDossierDelete
